<template>
  <main-template>
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1 class="text-h5 mb-2">Configuração Bancária</h1>
          <p class="text--secondary mb-4">Dados bancários da franquia para emissão de boletos.</p>
        </v-col>
      </v-row>

      <v-row v-if="carregando">
        <v-col cols="12">
          <v-skeleton-loader loading type="article" />
        </v-col>
      </v-row>

      <v-form v-if="!carregando" ref="form" @submit.prevent="salvar">
        <v-card class="mb-4" outlined>
          <v-card-title class="subtitle-1">Identificação</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="3">
                <e-label>Número do Banco</e-label>
                <v-text-field v-model="form.numero_banco" dense solo placeholder="Ex: 001" />
              </v-col>
              <v-col cols="12" md="9">
                <e-label>Descrição</e-label>
                <v-text-field
                  v-model="form.descricao"
                  dense
                  solo
                  placeholder="Ex: Banco do Brasil"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mb-4" outlined>
          <v-card-title class="subtitle-1">Conta Bancária</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="5">
                <e-label>Conta</e-label>
                <v-text-field v-model="form.conta" dense solo />
              </v-col>
              <v-col cols="12" md="2">
                <e-label>DV Conta</e-label>
                <v-text-field v-model="form.conta_dv" dense solo />
              </v-col>
              <v-col cols="12" md="3">
                <e-label>Agência</e-label>
                <v-text-field v-model="form.agencia" dense solo />
              </v-col>
              <v-col cols="12" md="2">
                <e-label>DV Agência</e-label>
                <v-text-field v-model="form.agencia_dv" dense solo />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mb-4" outlined>
          <v-card-title class="subtitle-1">Carteira e Convênio</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="3">
                <e-label>Carteira</e-label>
                <v-text-field v-model="form.carteira" dense solo />
              </v-col>
              <v-col cols="12" md="3">
                <e-label>Variação da Carteira</e-label>
                <v-text-field v-model="form.variacao_carteira" dense solo />
              </v-col>
              <v-col cols="12" md="3">
                <e-label>Convênio</e-label>
                <v-text-field v-model="form.convenio" dense solo />
              </v-col>
              <v-col cols="12" md="3">
                <e-label>Número do Convênio</e-label>
                <v-text-field v-model="form.numero_convenio" type="number" dense solo />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <e-label>Modalidade</e-label>
                <v-text-field v-model="form.modalidade" type="number" dense solo />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mb-4" outlined>
          <v-card-title class="subtitle-1">Encargos Financeiros</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <e-label>Juros (%)</e-label>
                <v-text-field v-model="form.juros" type="number" step="0.01" dense solo />
              </v-col>
              <v-col cols="12" md="4">
                <e-label>Juros Mora (%)</e-label>
                <v-text-field v-model="form.juros_mora" type="number" step="0.01" dense solo />
              </v-col>
              <v-col cols="12" md="4">
                <e-label>Multa (%)</e-label>
                <v-text-field v-model="form.multa" type="number" step="0.01" dense solo />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mb-4" outlined>
          <v-card-title class="subtitle-1">Protesto</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <e-label>Dias de Protesto</e-label>
                <v-text-field v-model="form.diasProtestos" type="number" dense solo />
              </v-col>
              <v-col cols="12" md="4">
                <e-label>Quantidade de Dias de Protesto</e-label>
                <v-text-field v-model="form.quantidade_dias_protesto" type="number" dense solo />
              </v-col>
              <v-col cols="12" md="4">
                <e-label>Dias após Vencimento</e-label>
                <v-text-field
                  v-model="form.quantidade_de_dias_apos_vencimento"
                  type="number"
                  dense
                  solo
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mb-4" outlined>
          <v-card-title class="subtitle-1">Mensagens do Boleto</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <e-label>Mensagem 1</e-label>
                <v-text-field v-model="form.msg1" dense solo />
              </v-col>
              <v-col cols="12" md="4">
                <e-label>Mensagem 2</e-label>
                <v-text-field v-model="form.msg2" dense solo />
              </v-col>
              <v-col cols="12" md="4">
                <e-label>Mensagem 3</e-label>
                <v-text-field v-model="form.msg3" dense solo />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <e-label>Instrução Adicional</e-label>
                <v-textarea v-model="form.instrucao_adicional" dense solo rows="3" />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mb-6" outlined>
          <v-card-title class="subtitle-1">Status</v-card-title>
          <v-card-text>
            <v-switch
              v-model="form.situacao"
              :true-value="1"
              :false-value="0"
              label="Ativo"
              inset
              color="primary"
            />
          </v-card-text>
        </v-card>

        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn color="primary" type="submit" :loading="salvando" large>
              <v-icon left>mdi-content-save</v-icon>
              {{ isNew ? "Criar Configuração" : "Salvar Alterações" }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BancosPage",

  computed: {
    ...mapGetters("Auth", ["user"]),
  },

  data() {
    return {
      carregando: false,
      salvando: false,
      isNew: true,
      bancoId: null,
      form: {
        configuracao_id: null,
        descricao: null,
        conta: null,
        conta_dv: null,
        agencia: null,
        agencia_dv: null,
        carteira: null,
        variacao_carteira: null,
        convenio: null,
        juros: null,
        multa: null,
        diasProtestos: null,
        quantidade_dias_protesto: null,
        quantidade_de_dias_apos_vencimento: null,
        numero_banco: null,
        msg1: null,
        msg2: null,
        msg3: null,
        instrucao_adicional: null,
        situacao: 0,
        juros_mora: null,
        modalidade: null,
        numero_convenio: null,
      },
    };
  },

  async mounted() {
    const franquiaId = this.$route.params.franquiaId;
    this.form.configuracao_id = franquiaId;
    await this.carregarBanco(franquiaId);
  },

  methods: {
    async carregarBanco(franquiaId) {
      this.carregando = true;
      try {
        const banco = await this.$services.bancosService.getBanco(franquiaId);
        if (banco && banco.id) {
          this.isNew = false;
          this.bancoId = banco.id;
          this.form = { ...banco };
        } else {
          this.isNew = true;
        }
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },

    async salvar() {
      this.salvando = true;
      try {
        if (this.isNew) {
          const criado = await this.$services.bancosService.criarBanco(this.form);
          this.isNew = false;
          this.bancoId = criado.id;
          this.form = { ...criado };
          this.$toast.success("Configuração bancária criada com sucesso!");
        } else {
          const atualizado = await this.$services.bancosService.atualizarBanco(
            this.bancoId,
            this.form
          );
          this.form = { ...atualizado };
          this.$toast.success("Configuração bancária atualizada com sucesso!");
        }
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>
